(function(){
    'use strict';
    const accordionBox = document.querySelectorAll(".accordion__box")
    accordionBox.forEach(accordion => {
        accordion.addEventListener("click", function(e){
            e.currentTarget.classList.toggle("active")
        })
    })    
}());

